import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { coerceDateCells } from "./excelDateCells";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

export const exportToExcel = (csvData, fileName) => {
  console.log({ csvData, fileName })
  const ws = coerceDateCells(XLSX.utils.json_to_sheet(csvData));
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellDates: true });
  const data = new Blob([excelBuffer], { type: fileType });
  console.log({ data })
  FileSaver.saveAs(data, fileName + fileExtension);
};

// sheets: [{ name: "Summary", data: [...] }, { name: "Case Details", data: [...] }]
// Sheet names are truncated to Excel's 31-char limit and de-duplicated so two
// same-named sheets (or a name collision after truncation) don't silently
// overwrite each other in the workbook.
export const exportToExcelMultiSheet = (sheets, fileName) => {
  const wb = { Sheets: {}, SheetNames: [] };
  const usedNames = new Set();
  sheets.forEach(({ name, data }) => {
    let sheetName = (name || "Sheet").slice(0, 31);
    let suffix = 1;
    while (usedNames.has(sheetName)) {
      const suffixStr = ` (${++suffix})`;
      sheetName = name.slice(0, 31 - suffixStr.length) + suffixStr;
    }
    usedNames.add(sheetName);
    wb.Sheets[sheetName] = coerceDateCells(
      XLSX.utils.json_to_sheet(data && data.length ? data : [{}]),
    );
    wb.SheetNames.push(sheetName);
  });
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellDates: true });
  const blob = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(blob, fileName + fileExtension);
};
